import { render } from "./helpArticle.vue?vue&type=template&id=a2ca2c44&ts=true"
import script from "./helpArticle.vue?vue&type=script&lang=ts"
export * from "./helpArticle.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__